// Use the browsers crypto.randomUUID if set to generate a UUID
export function genUUID(crypto?: Crypto) {
  if (crypto && crypto.randomUUID) return crypto.randomUUID()
  return ('' + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => {
    const n = crypto && crypto.getRandomValues ? crypto.getRandomValues(new Uint8Array(1))[0] : Math.floor(Math.random() * 256)
    return ((c as unknown as number) ^ (n & (15 >> ((c as unknown as number) / 4)))).toString(16)
  })
}
